import React from "react";
import styled from "styled-components";
import saif from "../img/about/saif.jpg";
import { FadeIn } from "./AnimatedComponents";

const ImageSection: React.FC = () => {
  return (
    <ImageSectionStyled>
      <FadeIn direction="left">
        <div className="image-wrapper">
          <img src={saif} alt="Saif Al-Din Ali" />
        </div>
      </FadeIn>
      <FadeIn direction="right" delay={0.15}>
        <div className="bio-content">
          <h3>
            I am <span>Saif</span>
          </h3>
          <p>
            I'm a Software Engineer working across multiple Azure products —
            from cloud migration portals and CLI/Terraform extensions to
            appliance management systems and cost estimation tools. I'm also a
            published deep learning researcher with work accepted at IEEE ICMLA,
            VISAPP and ICECET.
          </p>
          <p>
            With experience spanning 10+ companies including Microsoft,
            Autodesk, Synopsys, Faire and BlackBerry, I specialize in building
            production-grade software across the full stack — from React and
            Angular frontends to C#/.NET and Python backends, cloud
            infrastructure with Azure and Terraform, and 3D rendering systems.
          </p>
        </div>
      </FadeIn>
    </ImageSectionStyled>
  );
};

const ImageSectionStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 3rem;
  margin-top: 3rem;
  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .image-wrapper {
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    aspect-ratio: 4 / 3;

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 20px;
      border: 1px solid var(--card-border);
      pointer-events: none;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s ease;
    }

    &:hover img {
      transform: scale(1.03);
    }
  }

  .bio-content {
    h3 {
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 1rem;

      span {
        background: linear-gradient(
          135deg,
          var(--primary-color),
          var(--primary-color-light)
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }

    p {
      font-size: 1rem;
      line-height: 1.8;
      color: var(--font-light-color);
    }
  }
`;

export default ImageSection;
